exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".headline[data-v-58a6f443]{text-align:center;font-size:.875rem;font-weight:400;line-height:1;margin-top:.1875rem;margin-bottom:.125rem;word-wrap:break-word}", ""]);

// exports
